let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2JtRU")).then(() => parcelRequire('79tj9'));